import { z } from 'zod';
import { CostNegotiationMode } from '../../../../../IPA/Negociacoes/pages/NegociacaoFornecedor/costNegotiation';
import { PRICE_MODES } from '../../../../../IPA/PrecoPsicologico/priceMode';

export const setupBasicConfigSchema = z.object({
  id: z.string().optional(),
  pricing_preferences: z.enum(['STORE', 'CLUSTER']),
  cost_field: z.string(),
  adjustemend_price_mode: z.enum(PRICE_MODES).optional(),
});

export const setupBasicConfigResponseSchema = setupBasicConfigSchema.extend({
  negotiation_cost: z.nativeEnum(CostNegotiationMode).nullable(),
  // Pode vir com o nome legado (NEW/OLD) ou vazio; normalizar com normalizePriceMode antes de usar.
  adjustemend_price_mode: z.string().nullable().optional(),
});

export type SetupBasicConfigSchema = z.infer<typeof setupBasicConfigSchema>;
export type SetupBasicConfigResponseSchema = z.infer<typeof setupBasicConfigResponseSchema>;
